export default {
  inject: ['load'],
  data() {
    return {
      allHeadacheOtherSpecificationsForOther: [],
      headacheOtherSpecification: null,
    };
  },
  methods: {
    getListOfHeadacheOtherSpecificationsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllHeadacheOtherSpecifications').then(() => {
        if (this.$store.state.headacheOtherSpecificationModule.successFlag) {
          this.allHeadacheOtherSpecificationsForOther =
            this.$store.state.headacheOtherSpecificationModule.allHeadacheOtherSpecifications;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.headacheOtherSpecificationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfHeadacheOtherSpecificationsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getHeadacheOtherSpecificationFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getHeadacheOtherSpecification', id).then(() => {
        if (this.$store.state.headacheOtherSpecificationModule.successFlag) {
          this.headacheOtherSpecification =
            this.$store.state.headacheOtherSpecificationModule.headacheOtherSpecification;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.headacheOtherSpecificationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getHeadacheOtherSpecificationFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.headacheOtherSpecificationModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
